(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var showPopup = function showPopup() {
            var overlay = document.getElementById('gptPopupOverlay');
            if (!overlay) return;

            overlay.classList.add('active');
            document.body.style.overflow = 'hidden'; // блокируем скролл
        };

        var hidePopup = function hidePopup() {
            var overlay = document.getElementById('gptPopupOverlay');
            if (!overlay) return;

            overlay.classList.remove('active');
            document.body.style.overflow = ''; // возвращаем скролл
        };

        // Обработчик клика по вопросу
        eventDispatcher.on('click', '.hotel-gpt-opinion__question', function (event, element) {
            showPopup();
        });

        // Обработчик клика по кнопке внутри
        eventDispatcher.on('click', '.gpt-popup-button', function (event, element) {
            hidePopup();
        });

        // Закрытие попапа по клику на оверлей
        document.addEventListener('DOMContentLoaded', function () {
            var overlay = document.getElementById('gptPopupOverlay');
            if (!overlay) return;

            overlay.addEventListener('click', function (e) {
                if (e.target === overlay) {
                    hidePopup();
                }
            });
        });
    }, {}] }, {}, [1]);